var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 21L28 25M2 25V11c0-1.105.895-2 2-2h5M18.445 25c-.706 1.236-2.021 2-3.445 2s-2.739-.764-3.445-2H0v2c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4v-2H18.445zM23.879 1.348c-3.205-.958-6.674.057-8.857 2.591-2.183 2.534-2.674 6.114-1.253 9.142l-2.752 5.586 6.298-1.72c.555.318 1.145.572 1.758.756 4.487 1.24 9.138-1.348 10.45-5.814 1.31-4.467-1.205-9.159-5.65-10.54l.006-.001z",
    transform: "translate(9 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.01 7.543c0-1.381 1.119-2.5 2.5-2.5 1.38 0 2.5 1.119 2.5 2.5 0 1.38-1.12 2.5-2.5 2.5M21.51 13.043c-.277 0-.5.224-.5.5s.223.5.5.5c.275 0 .5-.224.5-.5 0-.133-.053-.26-.147-.354-.094-.094-.22-.147-.354-.146h0",
    transform: "translate(9 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3330f6c11db232408389fcafebf5adae.svg";
export { ForwardRef as ReactComponent };